import { render, staticRenderFns } from "./ShowPowerGuardQuestions.vue?vue&type=template&id=32373918&"
import script from "./ShowPowerGuardQuestions.vue?vue&type=script&lang=js&"
export * from "./ShowPowerGuardQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports